import React from "react";
import { Droppable } from "@hello-pangea/dnd";
import "./Snippets.css";

export default function SnippetCode({
  code,
  revealed,
  selectedSnippets,
  correctSnippets,
  onSelectedSnippets,
}: {
  code: string;
  revealed: boolean;
  selectedSnippets: string[];
  correctSnippets: string[];
  onSelectedSnippets: (snippets: string[]) => void;
}) {
  const replaceSnippetPlaceholders = (text: string) => {
    return text.split("/*[Snippet]*/").map((part, index, arr) => {
      if (index < arr.length - 1) {
        const content = selectedSnippets[index];

        const snippetIsCorrect =
          selectedSnippets[index] === correctSnippets[index];

        if (revealed) {
          if (snippetIsCorrect) {
            // correct snippet
            return (
              <span key={index}>
                {part}
                <span className={"custom-box correctsnippet"}>
                  {selectedSnippets[index]}
                </span>
              </span>
            );
          }

          // incorrect snippet
          return (
            <span key={index}>
              {part}
              <span className={"custom-box incorrectsnippet"}>
                <s>{selectedSnippets[index]}</s>
                <span className="correct_in_incorrectsnippet">
                  {correctSnippets[index]}
                </span>
              </span>
            </span>
          );
        }

        // unrevealed snipppet
        return (
          <span key={index}>
            {part}
            <Droppable
              key={"key-" + index}
              droppableId={index.toString()}
              direction="horizontal"
            >
              {(provided) => (
                <span
                  className={"custom-box"}
                  onClick={() => {
                    let newSelectedSnippets = [...selectedSnippets];
                    newSelectedSnippets[index] = "";
                    onSelectedSnippets(newSelectedSnippets);
                  }}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{
                    cursor: content !== "" ? "pointer" : undefined,
                  }}
                >
                  {content === "" || content === undefined ? " " : content}
                  {provided.placeholder}
                </span>
              )}
            </Droppable>
          </span>
        );
      }
      return part; // der letzte Teil hat kein SNIPPET danach
    });
  };

  return (
    <>
      <pre>
        {/* <code>{replaceSnippetsWithCounters(code)}</code> */}
        <code className="snippetsCode">{replaceSnippetPlaceholders(code)}</code>
      </pre>
    </>
  );
}
